import { render, staticRenderFns } from "./AuthenticationMethods.vue?vue&type=template&id=00922b70&"
import script from "./AuthenticationMethods.vue?vue&type=script&lang=js&"
export * from "./AuthenticationMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports